import TableAction from '../../../../components/TableAction/TableAction'
import { fetchSemantics, deleteTopicSemanticDB, deleteSubTopicSemanticDB, 
  addSubTopicSemanticDB, addTopicSemanticDB, fetchTopicAllSemanticsDB, fetchSubTopicAllSemanticsDB,
  updateSemanticWord, addSubTopicSemanticDBwords, fetchSubtopicSemantics, addSubTopicSemanticDBwordsWithWeights } from '../../../../services/LingvoSemanticAPI'
import * as XLSX from 'xlsx'
import ProcessSpinner from '../../../../components/ProcessSpinner/ProcessSpinner'
import { Alert } from 'react-bootstrap';
import Semantic from '../../../../components/Controlls/Semantic/Semantic'
import TreeViewTopics from './components/TreeViewTopics/TreeViewTopics';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React, { useState, useEffect, useContext, useCallback } from 'react';
import { TopicsSubTopicsContext, WhatSelected } from '../../context/TopicsSubTopics';
import { removeWords } from './utils';
import TableSemanticTokens from './components/TableSemanticTokens/TableSemanticTokens';
import { Button, Badge } from 'react-bootstrap';


function TopicsSemantic() {

    // Topics - SubTopics
    const {
        whatSelected,
        errorTopicsSubTopics, setErrorTopicsSubTopics,  
        selectedTopicOrSubtopicIndex,
        isLoadingTopicsSubTopics, setIsLoadingTopicsSubTopics,
        selectedTopicOrSubtopicName,
    } = useContext(TopicsSubTopicsContext);
    
    // Semantic
    const [language, setLanguage] = useState('rus');
    const [spelling, setSpelling] = useState(false);
    const [top, setTop] = useState(10);
    const [semantics, setSemantics] = useState([]);
    const [selectedSemanticIndex, setSelectedSemanticIndex] = useState(null);
    const [isLoadingSemantic, setIsLoadingSemantic] = useState(false);
    const [errorSemantic, setErrorSemantic] = useState(null);

    // Semantic DB
    const [semanticsDB, setSemanticsDB] = useState([]);
    const [isLoadingSemanticDB, setLoadingSemanticDB] = useState(false);

    useEffect(() => {
        console.log('selectedTopicOrSubtopicName', selectedTopicOrSubtopicName);
        console.log(whatSelected);
    }, [selectedTopicOrSubtopicName]);

    // useEffect срабатывает при изменении selectedTopicOrSubtopicName
    useEffect(() => {
        if (selectedTopicOrSubtopicName !== '') {
            setSemanticsDB([]);
            setSemantics([]);
            console.log('TopicsSemantic -> selectedTopicOrSubtopicIndex', selectedTopicOrSubtopicIndex);
            async function fetchDataSemanticDB() {
                try {
                    let data = [];
                    switch (whatSelected) {
                      case WhatSelected.TOPIC:
                        data = await fetchTopicAllSemanticsDB(selectedTopicOrSubtopicIndex);
                        break;
                      case WhatSelected.SUBTOPIC:
                        data = await fetchSubTopicAllSemanticsDB(selectedTopicOrSubtopicIndex);
                        break;
                    }
                    setSemanticsDB(data.sort());  // .map(item => item.word)
                } catch (error) {
                    console.log(error);
                } finally {
                }
            }
            fetchDataSemanticDB();
        } else {
            setSemantics([]);
            setSemanticsDB([]);
        }
    }, [selectedTopicOrSubtopicName, selectedTopicOrSubtopicIndex]); // зависимость — count

    // Обработчик загрузки генерированных семантических токенов
    const generateSemantics = async () => {
        setIsLoadingSemantic(true);
        try {
            let data = [];
            if (whatSelected === WhatSelected.TOPIC) {
              data = await fetchSemantics(selectedTopicOrSubtopicName, language, spelling, top)
            } else {
              data = await fetchSubtopicSemantics(selectedTopicOrSubtopicIndex, selectedTopicOrSubtopicName, language, spelling, top)
            }
            //console.log('words_not_exist_in_db', data.words, semanticsDB.map( (item) => item.lemma));
            const words_not_exist_in_db = removeWords(data.words, semanticsDB.map( (item) => item.lemma));
            setSemantics(words_not_exist_in_db.sort());
        } catch (error) {
            console.log(error);
            setErrorSemantic('Ошибка при генерирование семантического ядра')
        } finally {
            setIsLoadingSemantic(false);
        }
    };

    // Обработчик удаления семантики из БД для выделенного топика
    const semanticWordDbDelete = async (semanticWordId) => {
        const semantic_word = semanticsDB.find(item => item.id === semanticWordId);
        if (!semantic_word) {
            console.error('Токен не найден для удаления');
            return;
        }
        console.log(semantic_word);
        // Сохраняем копию для возможного восстановления
        const previousSemanticsDB = [...semanticsDB];
        setSemanticsDB(semanticsDB.filter(item => item.id !== semanticWordId));
        try {
            switch (whatSelected) {
              case WhatSelected.TOPIC:
                await deleteTopicSemanticDB(semantic_word.id);
                break;
              case WhatSelected.SUBTOPIC:
                await deleteSubTopicSemanticDB(semantic_word.id);
                break;
              default:
                console.log('В дереве интерресов и суб-интересов нет выбраного');
            }
        } catch (error) {
            setErrorSemantic(`Ошибка при удалении semantic_word: ${error.message}`);
            // Восстанавливаем элемент в случае ошибки
            setSemanticsDB(previousSemanticsDB);
        }
    };
    
    // Обработчик переноса слова из семантики в БД
    const semanticTransfer = async (selectedSemantics) => {
        selectedSemantics.forEach(async (semanticWord) => {
          console.log('transfer:', semanticWord);
          try {
              //await addTopicSemanticDB(selectedTopicOrSubtopicName, semanticWord);
              console.log('semanticTransfer -> whatSelected', whatSelected);
              let result = null
              switch (whatSelected) {
                case WhatSelected.TOPIC:
                  result = await addTopicSemanticDB(selectedTopicOrSubtopicIndex, semanticWord, false);
                  break;
                case WhatSelected.SUBTOPIC:
                  result = await addSubTopicSemanticDB(selectedTopicOrSubtopicIndex, semanticWord, false);
                  break;
                default:
                  console.log('В дереве интерресов и суб-интересов нет выбраного');
              }
              
              if (result != null) { 
                setSemanticsDB(semanticsDB => [...semanticsDB, result]);
              }
          } catch (error) {
              //setError(`Ошибка при перемещении semantic: ${error.message}`);
              console.log(`Ошибка при перемещении semantic: ${error.message}`);
          }
        }); 
        setSemantics(semantics.filter(item => !selectedSemantics.includes(item)));
    }

    function get_updateSemanticWord() {
        switch (whatSelected) {
          case WhatSelected.TOPIC:
            return updateSemanticWord('topics');
          case WhatSelected.SUBTOPIC:
            return updateSemanticWord('sub-topics');
          default:
            console.log('[get_updateSemanticWord] В дереве интерресов и суб-интересов нет выбраного');
        }
    }

  const handleFileUpload = useCallback(async (event) => {

      const file = event.target.files[0];
      console.log('handleFileUpload ...');

      if (!file) return;
      
      const fileName = file.name.toLowerCase();
      const isExcel = fileName.endsWith('.xlsx') || fileName.endsWith('.xls');
      const isTxt = fileName.endsWith('.txt');
      
      // Проверяем расширение файла
      if (!isExcel && !isTxt) {
        alert('Пожалуйста, выберите файл с расширением .txt, .xlsx или .xls');
        return;
      }

      try {
        setLoadingSemanticDB(true);
        
        if (isExcel) {
          // Обработка Excel файла
          const reader = new FileReader();
          
          reader.onload = async (e) => {
            try {
              const arrayBuffer = new Uint8Array(e.target.result);
              const workbook = XLSX.read(arrayBuffer, { type: 'array' });
              
              // Берем первую вкладку
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];
              
              // Конвертируем в JSON массив массивов
              const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });
              
              // Обрабатываем данные: первая колонка - слово, вторая - вес
              const wordsWithWeights = [];
              for (let i = 0; i < jsonData.length; i++) {
                const row = jsonData[i];
                if (row.length >= 2 && row[0] && row[1] !== undefined && row[1] !== '') {
                  const word = String(row[0]).trim();
                  const weight = parseFloat(row[1]);
                  
                  // Пропускаем пустые слова и невалидные веса
                  if (word && !isNaN(weight)) {
                    // Фильтруем слова: оставляем только буквы, длина <= 30
                    const cleanWord = word.replace(/[^а-яА-Яa-zA-Z]/g, '');
                    if (cleanWord.length > 0 && cleanWord.length <= 30) {
                      wordsWithWeights.push({
                        word: cleanWord,
                        weight: weight
                      });
                    }
                  }
                }
              }
              
              if (wordsWithWeights.length === 0) {
                alert('В файле не найдено валидных данных. Убедитесь, что файл содержит две колонки: слово и вес.');
                return;
              }
              
              // Отправляем на сервер
              const result = await addSubTopicSemanticDBwordsWithWeights(selectedTopicOrSubtopicIndex, wordsWithWeights);
              
              // Обновляем список токенов в БД
              // Перезагружаем все токены из БД для отображения обновленных весов
              let data = [];
              switch (whatSelected) {
                case WhatSelected.TOPIC:
                  data = await fetchTopicAllSemanticsDB(selectedTopicOrSubtopicIndex);
                  break;
                case WhatSelected.SUBTOPIC:
                  data = await fetchSubTopicAllSemanticsDB(selectedTopicOrSubtopicIndex);
                  break;
              }
              setSemanticsDB(data.sort());
            } catch (error) {
              console.log(`Ошибка при обработке Excel файла: ${error.message}`);
              alert(`Ошибка при обработке Excel файла: ${error.message}`);
            } finally {
              setLoadingSemanticDB(false);
            }
          };
          
          reader.readAsArrayBuffer(file);
        } else {
          // Обработка TXT файла (существующая логика)
          const reader = new FileReader();
          
          reader.onload = async (e) => {
            const content = e.target.result;
            // Разбиваем на слова и фильтруем
            const words = content.split('\n')
              .map(word => word.trim())
              .map(word => word.replace(/[^а-яА-Яa-zA-Z]/g, ''))
              .filter(word => word.length > 0)
              .filter(word => word.length <= 30); // фильтруем слова длиннее 30 символов
            //console.log('words', words);
            try {
              const result = await addSubTopicSemanticDBwords(selectedTopicOrSubtopicIndex, words);
              setSemanticsDB(semanticsDB => [...semanticsDB, ...result]);
            }
            catch (error) {
              console.log(`Ошибка при записи в semanticDB слов: ${error.message}`);
            } finally {
              setLoadingSemanticDB(false);
            }
          };
          
          reader.readAsText(file);
        }
      } catch (error) {
        console.log(`Ошибка при загрузке файла: ${error.message}`);
        alert(`Ошибка при загрузке файла: ${error.message}`);
        setLoadingSemanticDB(false);
      }
      
      event.target.value = '';  // для повторного открытие одно и того же файла 
    });

    return <>
        <Row>
        <Col style={{ marginRight: '10px', width: '300px', flex: 'none' }}>
          <Row>
            <Col style={{ padding: '0px', alignContent: 'center'}}><h4>Интересы:</h4></Col>
          </Row>
          <Row>
            { errorTopicsSubTopics && <Alert variant="danger" onClose={() => setErrorTopicsSubTopics(null)} dismissible>{errorTopicsSubTopics}</Alert> }
            { isLoadingTopicsSubTopics ? (
              <ProcessSpinner></ProcessSpinner>
            ) : (
              <TreeViewTopics></TreeViewTopics>
            )}  
          </Row>
        </Col>
        <Col style={{ marginRight: '10px' }}>
          <Row>
            <Col style={{ padding: '0px', alignContent: 'center'}}><h4>Семантика (модель):</h4></Col>
            <Col>
              <Semantic language={language} setLanguage={setLanguage} spelling={spelling} setSpelling={setSpelling} 
                        top={top} setTop={setTop}>
              </Semantic>
            </Col>
          </Row>
          <Row>
            { isLoadingSemantic ? (
              <ProcessSpinner></ProcessSpinner>
            ) : (
              semantics.length > 0 ? (
                <>
                  <TableAction title="Название" action_name="Перенести" action={semanticTransfer} data={semantics} selectedRowIndex={selectedSemanticIndex} 
                    setSelectedRowIndex={setSelectedSemanticIndex} selectedTopicOrSubtopicIndex={selectedTopicOrSubtopicIndex}></TableAction>
                  <p>Всего токенов: {semantics.length}</p>
                </>
              ) : (
                 <Button variant="primary" style={{margin: 'auto', width: '100%' }} 
                          disabled={selectedTopicOrSubtopicName === ''}
                          onClick={generateSemantics}>Генерировать</Button>
              )
            )}  
            { errorSemantic && <Alert variant="danger" onClose={() => setErrorSemantic(null)} dismissible>{errorSemantic}</Alert> }
          </Row>
        </Col>
        <Col>
          <Row>
            <Col style={{ padding: '0px', alignContent: 'center', marginBottom: '10px', marginTop: '15px'}}><h4>Семантика (БД):</h4></Col>
          </Row>
          <Row>
            <Button variant="primary" style={{marginBottom: '5px'}}
                    disabled={selectedTopicOrSubtopicName === '' || whatSelected == WhatSelected.TOPIC} 
                    onClick={() => document.getElementById('fileInput').click()}>
              Загрузить из файла
              <input 
                id="fileInput"
                type="file" 
                accept=".txt,.xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" 
                style={{display: 'none'}} 
                onChange={handleFileUpload}
              />  
            </Button>
          </Row>
          <Row>
            { isLoadingSemanticDB ? (
              <ProcessSpinner></ProcessSpinner>
            ) : (
              <TableSemanticTokens 
                title="Название" 
                action={semanticWordDbDelete} 
                action_name="Удалить" 
                data={semanticsDB} 
                selectedRowIndex={() => null} 
                setSelectedRowIndex={() => null} 
                updateSemanticWord={get_updateSemanticWord()}
                onDataUpdate={async () => {
                  // Перезагружаем данные из БД после обновления
                  let data = [];
                  switch (whatSelected) {
                    case WhatSelected.TOPIC:
                      data = await fetchTopicAllSemanticsDB(selectedTopicOrSubtopicIndex);
                      break;
                    case WhatSelected.SUBTOPIC:
                      data = await fetchSubTopicAllSemanticsDB(selectedTopicOrSubtopicIndex);
                      break;
                  }
                  setSemanticsDB(data.sort());
                }}
              >  
              </TableSemanticTokens>
            )} 
          </Row>
        </Col>
      </Row>
    </>
}

export default TopicsSemantic;
